import React from "react";
import { Grid, Typography } from "@mui/material";
import SiTextField from "../si-textfield";
import moment from "moment";

const PreviewFormGenerator = ({ formValues, formConfig }) => {
  const formatValue = (value) => {
    if (!value) return "";

    if (value instanceof Date) {
      return moment(value).format("DD/MM/YYYY");
    }
    if (typeof value === "object") {
      return value.label || "";
    }
    return value;
  };

  return (
    <Grid container>
      {formConfig.map((field, index) => {
        return (
          Object.keys(field).length > 0 && (
            <Grid item md={4} xs={12} sx={{ pr: { md: 3, xs: 0 } }}>
              <p> {field.label}</p>
              <SiTextField
                value={formatValue(formValues[field.name])}
                placeholder={field.placeholder}
                type="text"
                disabled
                title={formatValue(formValues[field.name])}
              />
            </Grid>
          )
        );
      })}
    </Grid>
  );
};

export default PreviewFormGenerator;
